<!--
 * @Description  : 购票须知中的改签提示页
-->
<template minapp="mpx" xlang="wxml">
  <view>
    <children-table isShowTabIcon="{{isShowTabIcon}}" tableValue="{{tableValue1}}"></children-table>
    <explain class="explain1" explainValue="{{explainValue1}}"></explain>
    <explain class="explain2" explainValue="{{explainValue2}}"></explain>
    <explain class="explain3" explainValue="{{explainValue3}}"></explain>
    <notes class="notes1" notesList="{{notesList1}}"></notes>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    data: {
      isShowTabIcon:true,
      explainValue1: {
        title: '儿童票如何进站购票？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '使用儿童本人证件购票及取票进站（如儿童无身份证，请携带户口本）'
                }
              ]
            }
          ]
        ]
      },
      explainValue2: {
        title: '免费乘车儿童需办理什么手续？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '携带免费儿童须在乘车前，到站售票窗口办理申报手续'
                }
              ]
            }
          ]
        ]
      },
      explainValue3: {
        title: '儿童票怎么取票？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1. 儿童票取票证件：携带购票时所用儿童本人有效证件的原件'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '2.免费儿童申报：请在发车前到购票窗口办理申报证件明'
                }
              ]
            }
          ]
        ]
      },
      notesList1: [
        {
          title: '儿童票补票原则',
          list: [
            '列车到站发现应购买儿童优惠票而未买票的儿童，补收儿童优惠票票款',
            '发现应购买全价票而购买儿童优惠票乘车的未成年人，补收儿童优惠票价与全价票价的差额'
          ]
        }
      ],
      tableValue1: {
        title: '儿童票有什么优惠？（广九票除外）',
        tip: [
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '儿童票为'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #FF6221;'
            },
            children: [
              {
                type: 'text',
                text: '实名制'
              }
            ]
          },
          {
            name: 'span',
            attrs: {
              style: 'color: #666666;'
            },
            children: [
              {
                type: 'text',
                text: '，年龄和优惠区间如下:'
              }
            ]
          }
        ],
        tabWidth:['113px','68px','66px','88px'],
        tableth:['取票类型','票类型','票价','是否有座'],
        tablelist: [
          ['不满 6 周岁', '儿童', '免费', '无座'],
          ['年满 6 周岁且未满 14 周岁', '儿童', '优惠价', '有座'],
          ['14 周岁及以上', '成人', '全价', '有座']
        ],
        prompt: '注:每名持票成年人旅客可免费携带一名未满 6 周岁且不单独占用席位的儿童乘车，超过一名时，超过人数需购买儿童优惠票'
      }
    },
    mounted() {},
    computed: {},

    methods: {}
  })
</script>

<style scoped lang="stylus">
  .explain1
    margin-bottom 12px
  .explain2
    margin 12px 0
  .notes1
    margin-top 12px
    border-radius 8px
  .table-icon
    width 351px
    height 374px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      explain: '@/components/ticket-guide/explain',
      notes: '@/components/ticket-guide/notes',
      'refund-table': '@/components/ticket-guide/refund-table',
      'children-table': '@/components/ticket-guide/children-table'
    }
  }
</script>